'use strict';
import React from 'react';

/**
 * InputField-select style is available for select elements.
 * For consistency with markup and existing styles, the InputField--withIconButton
 * and InputField-iconButton elements are recommended except when using the multiple attribute.
 * Focus and disabled states are provided as well as an InputField-select--error modifier.
 *
 * Usage:
 *
 * ```Javascript
 * <Select>
 *   <option value="1">Value1</option>
 *   <option value="2">Value2</option>
 *   <option value="3">Value3</option>
 * </Select>
 * ```
 *
 * @extends {React.Component}
 * @property {Boolean} disabled Renders the select as disabled.
 */
class Select extends React.Component {
  /**
   * Creates the Select element
   * @return {JSX} Select Element
   */
  createSelect () {
    const { children, disabled, ...otherProps } = this.props;

    return (
      <div className="InputField">
        <select {...otherProps}
            className="InputField-select InputField-input--withIconButton"
            disabled={disabled}>
          {children}
        </select>
        <button disabled={disabled} className="InputField-iconButton Icon Icon--chevronDown" tabIndex="-1"></button>
      </div>
    );
  }

  /**
   *  Renders the component
   *
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      this.createSelect()
    );
  }
}

/**
 * @prop {Object} propTypes - Select properties with it's defined types
 */
Select.propTypes = {
  disabled: React.PropTypes.bool,
  multiple: React.PropTypes.bool
};

/**
 * @defaultProps {Object} propTypes - Select default properties values
 */
Select.defaultProps = {
  disabled: false,
  multiple: false,
  defaultValue: -1
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/select.jsx